module.exports = __webpack_public_path__ + "img/jdys.56b891e4.jpg";